import isNumber from 'lodash/isNumber'

const defaultOptions: Partial<Intl.NumberFormatOptions> = {
  style: 'currency',
  currency: 'USD',
}

export const toCurrencyString = (value: number, opts: Intl.NumberFormatOptions = defaultOptions) =>
  isNumber(value)
    ? isFinite(value)
      ? value.toLocaleString(typeof window !== 'undefined' ? window?.navigator?.language : 'en-US', {
          ...defaultOptions,
          minimumFractionDigits: 0,
          ...opts,
        })
      : value.toString()
    : value

export const toPercentageString = (
  value: number | null | undefined,
  language: string = 'en-US',
  minimumFractionDigits: number = 1,
  maximumFractionDigits: number = 1
): string => {
  if (value == null || !isFinite(value)) {
    return '0%'
  }

  return `${value.toLocaleString(language, {
    minimumFractionDigits,
    maximumFractionDigits,
  })}%`
}
